import { Loading } from '../loading/Loading';
import './processing-overlay.css';

interface ProcessingOverlayProps {
  message: string;
  description?: string;
  showLoading?: boolean;
  className?: string;
}

export function ProcessingOverlay({
  message,
  showLoading = true,
  description = '',
  className = '',
}: ProcessingOverlayProps) {
  return (
    <div className={`cometchat-calls-processing-overlay ${className}`}>
      {showLoading && <Loading />}
      <div className="cometchat-calls-processing-message">{message}</div>
      <div className="cometchat-calls-processing-message cometchat-calls-description">
        {description}
      </div>
    </div>
  );
}
